<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div>
            <ProfileInformationSection
                :user="localCompanyUserAggregate.user"
                :companyUser="localCompanyUserAggregate.companyUser"
            />
            <SideFormSectionDivider />
            <ResetPasswordSection />
            <SideFormSectionDivider />
            <GenericAvailabilitySection
                :entityWithAssociatedAvailability="localCompanyUserAggregate"
                :availabilities="localAvailabilities"
                :associateAvailabilityUrl="
                    urlFactory.makeCompanyUserAssociateAvailabilityUrl(
                        localCompanyUserAggregate.companyUser.id,
                    )
                "
            />
            <SideFormSectionDivider />
            <CompanyUserServicesSection
                :origin="EditServiceOriginEnum.ProfilePage"
                :companyUserAggregate="localCompanyUserAggregate"
                :services="localServices"
            />
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import ProfileInformationSection from '@/App/User/Component/MyProfile/ProfileInformationSection.vue'
    import ResetPasswordSection from '@/App/User/Component/MyProfile/ResetPasswordSection.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import Service from '@/App/Service/Entity/Service'
    import GenericAvailabilitySection from '@/App/Availability/Component/GenericAvailabilitySection.vue'
    import CompanyUserServicesSection from '@/App/CompanyUser/Component/CompanyUserServicesSection.vue'
    import SideFormSectionDivider from '@/Shared/Component/SideFormSectionDivider.vue'
    import { EditServiceOriginEnum } from '@/Shared/AutoGenerated/Main'
    import Availability from '@/App/Availability/Entity/Availability'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface ShowMyProfileProps {
        pageMeta: PageMeta
        appSharedDataData: any
        companyUserAggregateData: any
        servicesData: any
        availabilitiesData: any
    }

    const props = defineProps<ShowMyProfileProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localCompanyUserAggregate = ref<CompanyUserAggregate>(
        CompanyUserAggregate.hydrateSingle(props.companyUserAggregateData),
    )
    const localServices = ref<Service[]>(
        Service.hydrateMultiple(props.servicesData),
    )
    const localAvailabilities = ref<Availability[]>(
        Availability.hydrateMultiple(props.availabilitiesData),
    )
    const urlFactory = new UrlFactory()
</script>
